import React from "react";
import { Lock, Building2, Info } from "lucide-react";

/**
 * P9 — Three small trust signals shown below the Run Audit / Start My First
 * Audit buttons. Stacks vertically on mobile, single row on desktop.
 */
export default function TrustSignalsRow({ testId = "trust-signals-row" }) {
  return (
    <div
      className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-3 sm:gap-5 mt-3 text-[11px] text-[var(--rg-muted)]"
      data-testid={testId}
    >
      <span className="inline-flex items-center gap-1.5" data-testid="trust-secure">
        <Lock className="w-3.5 h-3.5 text-[var(--rg-sage)]" />
        Secure
      </span>
      <span className="inline-flex items-center gap-1.5" data-testid="trust-sources">
        <Building2 className="w-3.5 h-3.5 text-[var(--rg-sage)]" />
        Official sources only
      </span>
      <span className="inline-flex items-center gap-1.5" data-testid="trust-informational">
        <Info className="w-3.5 h-3.5 text-[var(--rg-sage)]" />
        Informational only — not legal advice
      </span>
    </div>
  );
}
